import { NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';

export class NextModuleCategoryStatusType extends NaniumObject<NextModuleCategoryStatusType> {
	// NextOfferType value ('ausbildung' | 'studium' | 'fsjbfd')
	@Type(String) offerType: string;
	@Type(Date) lastSuccessfulSyncAt?: Date;
	@Type(Number) activeCount: number;
	// last successful sync > 7 days ago (server clock — don't trust the client's)
	@Type(Boolean) stale: boolean;
	// emergency off-switch (plan §4.6)
	@Type(Boolean) disabled: boolean;
}

export class NextGetModuleStatusResponse extends NaniumObject<NextGetModuleStatusResponse> {
	@Type(Boolean) moduleDisabled: boolean;
	@Type(Array, NextModuleCategoryStatusType) categories: NextModuleCategoryStatusType[];
}

export class NextGetModuleStatusRequestBody extends NaniumObject<NextGetModuleStatusRequestBody> {
}

@RequestType({
	responseType: NextGetModuleStatusResponse,
	genericTypes: { TRequestBody: NextGetModuleStatusRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class NextGetModuleStatusRequest extends ServiceRequestBase<NextGetModuleStatusRequestBody, NextGetModuleStatusResponse> {
	static serviceName: string = 'NaniumDemo:next/getModuleStatus';
}
